// phonics_data_lt14.js
// Letter Teams L14 - L14 Long Vowel Sounds ch, tch
// 路由：/phonics/lt14

const MEDIA_BASE = '/media/phonics/lt14';
const V = 'v1';

export const letterDataLt14 = {
  id: 'lt14',
  letter: 'L14',
  title: 'L14 Long Vowel Sounds ch, tch',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1) → part1.mp4
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3) → part3.mp4
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）→ review.png
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P7/P8/P9: 三段故事（只有英文台词，无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "It is time for lunch.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "I have cheese.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "And I have chips.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "I want fish!", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "We can catch fish.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "The pals go to the shed.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "They get poles.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "They go to the lake.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Blue, what did you catch?", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "It is a brush.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Where are the fish?", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "There are no fish!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Look! Let's ask the sheep.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Did you catch fish?", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Yes.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "But I want cheese and chips.", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "We have cheese and chips.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Can we have a fish?", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
        { en: "Yes.", audioEn: `${MEDIA_BASE}/story3_7.mp3?${V}` },
        { en: "Here you go!", audioEn: `${MEDIA_BASE}/story3_8.mp3?${V}` },
      ],
    },
  ],
};
